import React from 'react';
import PropTypes from 'prop-types';

function FullScreenButton({ setIsFullScreen, isFullScreen }) {
  return (
    <a
      href='#'
      onClick={(e) => {
        e.preventDefault();
        setIsFullScreen(!isFullScreen);
      }}
    >
      <span className={`fa ${isFullScreen ? 'fa-compress' : 'fa-expand'}`}></span>
    </a>
  );
}

FullScreenButton.propTypes = {
  setIsFullScreen: PropTypes.func.isRequired,
  isFullScreen: PropTypes.bool.isRequired,
};

export default FullScreenButton;
